import React, { createContext, useContext } from 'react';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { useHasOnlyOneHumanPlayer } from '../../../store/selectors/useHasOnlyOneHumanPlayer.ts';
import { useRequestPause } from '../../../hooks/usePause.ts';
const UIGameHelpRulesButtonContext = /*#__PURE__*/ createContext(undefined);
export const useUIGameHelpRulesButtonContext = ()=>{
    const context = useContext(UIGameHelpRulesButtonContext);
    if (!context) throw new Error('UIGameHelpRulesButtonContext not found');
    return context;
};
export const UIGameHelpRulesButtonProvider = ({ children })=>{
    const requestPause = useRequestPause();
    const hasOnlyOneHumanPlayer = useHasOnlyOneHumanPlayer();
    const onShowRulebook = useGameStore((state)=>state.gameClientConfig.onShowRulebook);
    const showRulesPopup = ()=>{
        if (hasOnlyOneHumanPlayer) requestPause();
        onShowRulebook();
    };
    return /*#__PURE__*/ React.createElement(UIGameHelpRulesButtonContext.Provider, {
        value: {
            showRulesPopup: showRulesPopup
        }
    }, children);
};
